import moment from "moment";
import { z } from "zod";

import { Command } from "../../types";
import { TaxDeclarationType } from "../../../../../api/graphql/schema.generated";

export const resetDeclarationApprovalSchema = z.object({
  command: z.literal(Command.ResetDeclarationApproval),
  date: z.custom<moment.Moment>((date) => moment.isMoment(date), {
    message: "Please select a date",
  }),
  declarationType: z.nativeEnum(TaxDeclarationType),
});

export type ResetDeclarationApprovalValues = z.infer<
  typeof resetDeclarationApprovalSchema
>;
